import { NgClass } from '@angular/common';
import { Component, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-custom-radio-button',
    imports: [
    NgClass
],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomRadioButtonComponent),
            multi: true
        },
    ],
    templateUrl: './custom-radio-button.component.html',
    styleUrl: './custom-radio-button.component.scss'
})
export class CustomRadioButtonComponent implements ControlValueAccessor {

  constructor() {}

  onChange: any = () => {}
  onTouch: any = () => {}
  val = ''
  @Input() question="Are you a University of Nebraska-Lincoln or Nebraska Wesleyan student?"
  @Input() buttons = [{label: "Yes", value:"1"}, {label: "No", value:"2"}]
  @Input() name = "radioButton"
  @Input() disabled = false
  @Input() required = true


  set value(val: string) {
    if(!this.disabled && (val !== undefined && this.val !== val)) {
      this.val = val
      this.onChange(val)
      this.onTouch(val)
    }
  }

  writeValue(value: any) {
    if (!this.disabled) {
      this.value = value
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn
  }

  isEnterKey(event: KeyboardEvent, val: string) {
    if (!this.disabled && event.key === 'Enter') {
      console.log('Enter key was pressed!', val);
      this.value = val
    }
  }
}
